// UUID validation regex (supports general UUID format)
const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

/**
 * Validates if a value is a valid UUID format.
 * @param {unknown} value - The value to validate
 * @returns {boolean} True if the value is a valid UUID string
 */
export const isValidUUID = (value) => (
  typeof value === 'string' && UUID_REGEX.test(value)
)
